import NoteStore from "../store/index";
import { Moment } from "moment";
import { mutatorAction } from "satcheljs";

export default mutatorAction('SET_NOTES_CACHE_START_TIME_IN_STORE', function setNotesCacheStartTimeInStore(notesCacheStartTime: Moment) {
    NoteStore().notesCacheStartTime = notesCacheStartTime;
});
